<div class="modal-body">
  <p class="text-center mb-5">{{ 'message.please-wait' | translate }}</p>
  <div class="d-flex align-items-center justify-content-center pb-3">
    <div>
      <app-loading-indicator-full></app-loading-indicator-full>
    </div>
  </div>
</div>
